<template>
  <BaseListPage
      :name="name"
      :table-set-list="tableSetList"
      :table-data-list="sortedList"
      :show-search-component="false"
      :show-pagination="false"
      title="顧客ランク"
      title-class="customer-rank-header"
      icon="point"
      table-class="row-clickable-table"
      @row-click="onRowClick">
    <template slot="search">
      <div class="search-dropdown">
        <label>顧客グループ</label>
        <BaseValidSelect :value="selectedGroup"
            :options="customerGroups"
            name="group"
            @input="onGroupChanged" />
        <BaseNewRegisterButton
            :store-path="storePath"
            url="customerrank" />
      </div>
    </template>
  </BaseListPage>
</template>

<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'

import x from '@/components/mixins/mixin'

import BaseListPage from '@/components/organisms/BaseListPage'
import BaseValidSelect from '@/components/atoms/BaseValidSelect'
import BaseNewRegisterButton from '@/components/organisms/BaseNewRegisterButton'

export default {
  name: 'CustomerRank',
  components: {
    BaseListPage,
    BaseValidSelect,
    BaseNewRegisterButton
  },
  mixins: [x],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      customerGroups: [],
      selectedGroup: null
    }
  },
  computed: {
    ...mapState({
      tableSetList: (state) => state.CustomerRank.tableSetList
    }),
    ...mapGetters({
      getSortedList: 'sortedList'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    name () {
      return 'customerRankList'
    },
    storePath () {
      return 'CustomerRank'
    },
    linkKey () {
      return 'code'
    },
    returnPath () {
      return '/customerrank'
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    _tableSetList () {
      return [
        { type: 'String', label: 'ランクコード', path: 'code', sortable: 'custom' },
        { type: 'String', label: 'ランク名称', path: 'name', sortable: 'custom' },
        { type: 'Number', label: 'ポイント付与倍率', path: 'rate', fractionDigits: 2, sortable: 'custom' }
      ]
    },
    listItems () {
      // TODO store の tdLists を絞り込む？
      return [
        { code: 1, name: '一般', rate: 1 },
        { code: 2, name: '優待', rate: 1.3 },
        { code: 3, name: '上客', rate: 1.5 }
      ]
    }
  },
  created () {
    this.$store.dispatch({
      type: 'set',
      states: {
        'CustomerRank/tableSetList': this._tableSetList
      }
    })
    this.$store.dispatch({
      type: 'set',
      states: {
        'CustomerRank/tdLists': this.listItems
      }
    })

    this.customerGroups = this.getCustomerGroups()
  },
  methods: {
    getCustomerGroups () {
      return [
        { code: 1, name: '顧客グループ１' },
        { code: 2, name: '顧客グループ２' },
        { code: 3, name: '顧客グループ３' }
      ]
    },
    onGroupChanged (event) {
      this.$log.debug('change event', event)
      this.selectedGroup = event
    },
    onRowClick (row, column, event) {
      const id = _.get(row, this.linkKey)
      const index = this.$_mixin_findIndex(this.sortedList, { [this.linkKey]: id })
      this.$_mixin_onLinkClick(index, this.storePath)
      this.$router.push({ path: `/customerrank/${id}` })
    }
  }
}
</script>
